import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '@tech-services/common.service';
import { LoginService } from '@tech-services/login.service';
import { SessionService } from '@tech-services/session.service';
import { data } from 'jquery';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TechDialogsService } from '../../../shared/tech-dialogs.service';

@Component({
  selector: 'tech-activateaccount',
  templateUrl: './activateaccount.component.html',
  styleUrls: ['./activateaccount.component.scss'],
})
export class ActivateaccountComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  private ta: string;
  constructor(
    private route: ActivatedRoute,
    private loginService: LoginService,
    private commonService: CommonService,
    private translate: TranslateService,
    private dialogService: TechDialogsService,
    private router: Router,
    private sessionService: SessionService
  ) {}

  ngOnInit() {
    this.ta = this.route.snapshot.paramMap.get('ta');
    this.activateAccount();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  private activateAccount() {
    this.loginService
      .activateaccount(this.ta)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        if (data.Status == 'OK') {
          this.sessionService.sessionToken = data.Token;
          localStorage.setItem('Language', localStorage.getItem('language'));
          this.sessionService.clientCode = data.Code;
          localStorage.setItem('ClientCode', data.code);
          this.commonService
            .automaticLogging(data.Code, data.Token)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((data) => {
              let text1: string;
              let text2: string;
              this.translate.get('k002066').subscribe((text: string) => {
                //Token: Gracias por crear su cuenta
                text1 = text;
              });
              this.translate.get('k002067').subscribe((text: string) => {
                //Token: Su cuenta ha sido confirmada satisfactoriamente. Ya puede acceder a su cuenta personal para continuar con el registro.
                text2 = text;
                this.dialogService.openModalDialog(
                  // 'exclamation-circle',
                  '',
                  text1,
                  text2,
                  ''
                );
              });
              this.sessionService.clientDataLogin = data;
              this.sessionService.sessionToken = data.SessionToken;
              this.sessionService.domain = data.Domain;
              localStorage.setItem('Language', this.sessionService.language);
              this.sessionService.clientCode = data.ClientCode;
              localStorage.setItem('ClientCode', data.ClientCode);
              this.sessionService.clientId = data.ClientId;
              localStorage.setItem('ClientId', data.ClientId);
              this.router.navigate(['/portfolios']);
            });
        }
      });
  }
}
